
















































import { Vue, Component, Prop } from 'vue-property-decorator';
import RaceData from '../types/RaceData';
import teamColors from '@/data/teamColors';

@Component
export default class RaceTable extends Vue {
  @Prop(Object)
  raceData: RaceData;

  totalTime(result: RaceData['results'][0]) {
    return result.laps.reduce((prev, curr) => prev + curr.laptime, 0);
  }

  diffToWinner(result: RaceData['results'][0]) {
    const winnerTotalTime = this.totalTime(this.raceData.results[0]);
    const currentTotalTime = this.totalTime(result);
    const diff = currentTotalTime - winnerTotalTime;
    if (diff >= 60) {
      return `${Math.floor(diff / 60)}:${(diff % 60).toFixed(3)}`;
    } else {
      return diff.toFixed(3);
    }
  }

  getTeamColor(teamName: string) {
    return {
      background: teamColors[teamName],
    };
  }

  getGapString(result: RaceData['results'][0]) {
    if (result.dnf) return 'DNF';
    const lapDiff = this.raceData.results[0].laps.length - result.laps.length;
    if (lapDiff > 0) return `+ ${lapDiff} ${lapDiff > 1 ? 'laps' : 'lap'}`;
    return result.position !== 1 ? `+${this.diffToWinner(result)}` : '';
  }

  pitStops(result: RaceData['results'][0]) {
    console.log(result);
    return result.laps.filter((lap) => lap.pit).length;
  }
}
